// src/LoginGuard.tsx
import { Navigate } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import { showManagedToast } from "@/util/toastManager";
import { useEffect, useRef } from "react"; // <--- CORRIGIDO AQUI: 'react' com 'r' minúsculo

export default function LoginGuard() {
    const dna = sessionStorage.getItem("dna");

    const hasShownToast = useRef(false);

    // useEffect para controlar a exibição do toast e resetar a flag
    useEffect(() => {
        // Se não há DNA e a mensagem ainda não foi mostrada, exibe.
        if ((!dna || dna.trim() === "") && !hasShownToast.current) {
            showManagedToast(
                "info",
                "Você precisa capturar o DNA da máquina para prosseguir.",
                "dna-required-redirect"
            );
            hasShownToast.current = true; // Marca que a mensagem foi mostrada
        }
            // Se o DNA existe (ou se a página já está visível com DNA),
            // reseta a flag para que o toast possa ser mostrado novamente se o DNA sumir.
        // Isso previne que a mensagem apareça se o usuário navegar para cá e já tiver DNA válido.
        else if (dna && dna.trim() !== "") {
            hasShownToast.current = false;
        }
    }, [dna]); // Depende de 'dna' para reavaliar a condição

    if (!dna || dna.trim() === "") {
        return <Navigate to="/" replace />;
    }

    return <LoginPage />;
}